import { useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { crefazService } from '../services/crefazService'
import { useEffect } from 'react'

type UseTermParams = {
  prazo: number
}

export function useTerm(params: UseTermParams) {
  const { data, isError, isFetching, isLoading, refetch } = useQuery({
    queryKey: ['getCommission', params.prazo],
    queryFn: () => crefazService.getCommission(params),
    enabled: !!params.prazo,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar a comissão, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    data,
    isError,
    isFetching,
    isLoading,
    refetch,
  }
}
